export enum IBoxTypeEnum {
    DEFAULT = "default",
    CUSTOM = "custom"
}

export enum IFieldTypeEnum {
    DEFAULT = "default",
    INDEX_FIELD = "index_field",
    DOCUMENT_FIELD = "document_field",
    DOCUMENT_CATEGORY = 'document_category'
}


export enum DocumentTypeGroupEnum {
    Overview = "overview",
    TopSection = "top_section",
    DocumentField = "document_field",
    Signature = "signature",
    Details = "details",
    Document = "document"
}


export enum DocumentTypeSectionEnum {
    ContractControlLayout = "cc_layout",
    ContractControlColumns = "cc_columns",
    ContractControlCategory = "cc_category",
    DocumentLayout = "document_layout",
    DocumentColumns = "document_columns",
    DocumentCategory = "document_category"
}

export enum DocumentTypeFieldNameEnum {
    // Top Section Fields
    DocumentType = "document_type",
    
    // Signature Group Fields
    SigningDeadline = "signing_deadline",
    SigningReminder = "signing_reminder",
    Language = "language",
    DocumentKey = "document_key",
    ExternalChat = "external_chat",
    InvitationMessage = "invitation_message",
    ConfirmationMessage = "confirmation_message",
    ActiveBcc = "active_bcc",
    Currency = "currency",
    AllowUploadFile = "allow_upload_file",
    SenderConfirmationType = "sender_confirmation_type",
    Status = 'status',
    
    // Details Group Fields
    Visibility = "visibility",
    TemplateRoles = "template_roles",
    ContractControlMultiSections = "contract_control_multi_sections",
    DueDate = "due_date",
    StatusUpdatedAt = "status_updated_at",
    Tags = "tags",
    
    // Document Columns Fields
    RecipientRoles = "recipient_roles",
    User = "user",
    Organization = "organization",
    
    // Contract Control Fields
    ContractNumber = "contract_number",
    ContractControlName = "contract_control_name",
    Name = "name",
    CategoryName = "category_name",
    StartDate = "start_date",
    EndDate = "end_date",
    Managers = "managers",
    Contacts = "contacts",
    ContractNo = "contract_no",
    CreatedAt = "created_at",
    Cost = "cost",
    Revenue = "revenue"
}




export enum AdjustableColumns {
    OrganizationName = "name",
    CategoryName = "category_name",
    StartDate = "start_date",
    EndDate = "end_date",
    Managers = "managers",
    Contacts = "contacts",
    ContractNo = "contract_no",
    CreatedAt = "created_at",
    Cost = "cost",
    Revenue = "revenue",
    Status = "status",
    RecipientRoles = "recipient_roles",
    OwnerColumn = "user",
    DocumentOrganization = "organization",
    LatestActivity = "status_updated_at"
}



export const DocumentDefaultColumns = [
  {
    type: "default",
    label: "Document - Listview - Columnname - Recipient",
    meta_data_id: null,
    is_adjustable: true,
    width: null,
    order: 1,
    doc_id: null,
    status: true,
    field_name: DocumentTypeFieldNameEnum.RecipientRoles,
  },
  {
    type: "default",
    label: "Document - Listview - Columnname - Owner",
    meta_data_id: null,
    is_adjustable: true,
    width: null,
    order: 2,
    doc_id: null,
    status: true,
    field_name: DocumentTypeFieldNameEnum.User,
  },
  {
    type: "default",
    label: "Document - Listview - Columnname - Organization",
    meta_data_id: null,
    is_adjustable: true,
    width: null,
    order: 3,
    doc_id: null,
    status: true,
    field_name: DocumentTypeFieldNameEnum.Organization,
  },
  {
    type: "default",
    label: "Latest Activity",
    meta_data_id: null,
    is_adjustable: true,
    width: null,
    order: 4,
    doc_id: null,
    status: true,
    field_name: DocumentTypeFieldNameEnum.StatusUpdatedAt,
  },
  {
    type: "default",
    label: "Status",
    meta_data_id: null,
    is_adjustable: true,
    width: null,
    order: 5,
    doc_id: null,
    status: true,
    field_name: DocumentTypeFieldNameEnum.Status,
  },
];


export const ContractControlDefaultColumns = [
  {
    type: "default",
    label: "Organization",
    order: 1,
    meta_data_id: null,
    is_adjustable: true,
    status: true,
    field_name: DocumentTypeFieldNameEnum.Name,
  },
  {
    type: "default",
    label: "Category",
    order: 2,
    meta_data_id: null,
    is_adjustable: true,
    status: true,
    field_name: DocumentTypeFieldNameEnum.CategoryName,
  },
  {
    type: "default",
    label: "Start date",
    order: 3,
    meta_data_id: null,
    is_adjustable: true,
    status: true,
    field_name: DocumentTypeFieldNameEnum.StartDate,
  },
  {
    type: "default",
    label: "End date",
    order: 4,
    meta_data_id: null,
    is_adjustable: true,
    status: true,
    field_name: DocumentTypeFieldNameEnum.EndDate,
  },
  {
    type: "default",
    label: "Managers",
    order: 5,
    meta_data_id: null,
    is_adjustable: true,
    status: true,
    field_name: DocumentTypeFieldNameEnum.Managers,
  },
  {
    type: "default",
    label: "Contacts",
    order: 6,
    meta_data_id: null,
    is_adjustable: true,
    status: true,
    field_name: DocumentTypeFieldNameEnum.Contacts,
  },
  {
    type: "default",
    label: "Contract no",
    order: 7,
    meta_data_id: null,
    is_adjustable: true,
    status: true,
    field_name: DocumentTypeFieldNameEnum.ContractNo,
  },
  {
    type: "default",
    label: "Created at",
    order: 8,
    meta_data_id: null,
    is_adjustable: true,
    status: true,
    field_name: DocumentTypeFieldNameEnum.CreatedAt,
  },
  {
    type: "default",
    label: "Monthly cost",
    order: 9,
    meta_data_id: null,
    is_adjustable: true,
    status: true,
    field_name: DocumentTypeFieldNameEnum.Cost,
  },
  {
    type: "default",
    label: "Revenue",
    order: 10,
    meta_data_id: null,
    is_adjustable: true,
    status: true,
    field_name: DocumentTypeFieldNameEnum.Revenue,
  },
  {
    type: "default",
    label: "Status",
    meta_data_id: null,
    is_adjustable: true,
    width: null,
    order: 11,
    doc_id: null,
    status: true,
    field_name: DocumentTypeFieldNameEnum.Status,
  },
];
